import React from 'react';

interface tooltipProps {
  showTooltip: boolean;
  text: string;
  isMobile?: boolean;
  variant?: 'default' | 'dark';
  width?: string;
  right?: string;
  arrowPosition?: 'left' | 'center' | 'right';
  customArrowLeft?: string;
}

export default function Tooltip(props: tooltipProps) {
  const {
    showTooltip,
    text,
    isMobile,
    variant = 'default',
    width = 'w-80',
    right = 'right-3',
    arrowPosition = 'right',
    customArrowLeft,
  } = props;

  // Define styles based on variant
  const getTooltipStyles = () => {
    const baseStyles =
      'absolute drop-shadow-lg top-10 p-5 z-50 whitespace-normal text-sm font-normal text-left rounded shadow-[0_5px_15px_0px_rgba(0,0,0,0.3)]';
    const positionStyles = `${right} ${width}`;

    if (variant === 'dark') {
      return `${baseStyles} ${positionStyles} bg-black text-white`;
    }

    // Default variant (maintain backward compatibility)
    return `${baseStyles} ${positionStyles} bg-white text-black`;
  };

  const getCaretStyles = () => {
    const baseCaretStyles =
      'content-none absolute top-0 w-[1rem] h-[1rem] rotate-45 translate-y-[-50%] translate-x-[-50%] shadow-[-20px_-4px_25px_-4px_rgba(0,0,0,0.6)]';

    // Dynamic arrow positioning
    let positionClass = '';
    if (customArrowLeft) {
      positionClass = customArrowLeft;
    } else {
      // Use predefined positions
      switch (arrowPosition) {
        case 'left':
          positionClass = 'left-[50%]';
          break;
        case 'center':
          positionClass = 'left-[50%]';
          break;
        case 'right':
        default:
          positionClass = isMobile ? 'left-[50%]' : 'left-[70%]';
          break;
      }
    }

    if (variant === 'dark') {
      return `${baseCaretStyles} ${positionClass} bg-black`;
    }

    // Default variant (maintain backward compatibility)
    return `${baseCaretStyles} ${positionClass} bg-white`;
  };
  return (
    <>
      {showTooltip && (
        <div className={getTooltipStyles()} data-testid="tooltip-test">
          <div className={getCaretStyles()}></div>
          {text}
        </div>
      )}
    </>
  );
}
